module.exports = __webpack_public_path__ + "img/logo2.8c914a15.png";